import React, { useState, useEffect, useCallback, useRef } from 'react'
import './style.css'
import Select from "react-select";
import { base, calculateDistance, services } from '../../constants/base';
import { useDispatch, useSelector } from 'react-redux';
import { handelResultClean, SearchFilterAPI } from '../../redux/slices/SearchFilterSlice';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation, Autoplay } from 'swiper/modules';

const QuickSearchBanner = () => {

    const dispatch = useDispatch()
    const [popularProfessionalsServices, setPopularProfessionalsServices] = useState([])
    const allResults = useSelector(state => state?.SearchFilterSlice?.results)
    const loading = useSelector(state => state?.SearchFilterSlice?.loading)

    const [quickSearchFilter, setQuickSearchFilter] = useState({
        name: null,
        start_price: null,
        end_price: null,
        radius: "all",
    })

    // GET USER CURRENT LOCATION
    const [location, setLocation] = useState({ lat: null, lng: null });
    const [error, setError] = useState(null);

    useEffect(() => {
        const requestLocation = () => {
            if ("geolocation" in navigator) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        setQuickSearchFilter({
                            ...quickSearchFilter,
                            latitude: position.coords.latitude,
                            longitude: position.coords.longitude,
                        });
                    },
                    (error) => {
                        console.error("Error getting location:", error);
                        switch (error.code) {
                            case error.PERMISSION_DENIED:
                                break;
                            case error.POSITION_UNAVAILABLE:
                                break;
                            case error.TIMEOUT:
                                break;
                            default:
                                break;
                        }
                    }
                );
            } else {
                console.log("Geolocation is not supported by your browser.");
            }
        };

        const checkPermission = async () => {
            if (navigator.permissions) {
                try {
                    const permissionStatus = await navigator.permissions.query({ name: "geolocation" });
                    if (permissionStatus.state === "granted") {
                        requestLocation();
                    } else if (permissionStatus.state === "prompt") {
                        requestLocation();
                    } else if (permissionStatus.state === "denied") {
                        console.log("Location access is blocked. Please enable location services in your browser settings and refresh the page.");
                    }
                } catch (err) {
                    console.error("Error checking permissions:", err);
                    requestLocation();
                }
            } else {
                requestLocation();
            }
        };

        checkPermission();
    }, []);

    // GET USER CURRENT LOCATION

    const handleServiceChange = (selectedOptions) => {
        const selectedValues = selectedOptions ? selectedOptions.map(option => option.label) : [];
        setPopularProfessionalsServices(selectedValues);
    };

    const handleFindQuickProfessionals = async () => {

        const updatedFilter = {
            ...quickSearchFilter,
            name: popularProfessionalsServices,
        };

        setQuickSearchFilter(updatedFilter);

        if (updatedFilter?.longitude && updatedFilter?.latitude) {
            const res = await dispatch(SearchFilterAPI(updatedFilter));
            if (!res.payload.status === 200) {
                toast.error("Data Loading Failed")
            }
        } else {
            alert("Please Enable Your Location First")
        }
    }

    useEffect(() => {
        return () => {
            dispatch(handelResultClean())

            setQuickSearchFilter({
                name: null,
                start_price: null,
                end_price: null,
                radius: "all",
            })
        }
    }, [])



    // SLIDER ARROWS
    const sliderRef = useRef();

    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);

    const handlePrev = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slidePrev();
    }, []);

    const handleNext = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slideNext();
    }, []);

    const handleSlideChange = (swiper) => {
        setIsBeginning(swiper.isBeginning);
        setIsEnd(swiper.isEnd);
    };
    // SLIDER ARROWS

    return (
        <>
            <div className="quick-search-banner">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="quick-search-main-box">
                                <div className="services-search-box">
                                    <Select
                                        isMulti
                                        name="name"
                                        options={services}
                                        className="input-search-filter"
                                        aria-label="Select the services"
                                        placeholder="Select Services"
                                        onChange={handleServiceChange}
                                    />
                                </div>

                                <div className="search-button-box">
                                    <button disabled={loading} className='btn btn-primary btn-box-home' onClick={handleFindQuickProfessionals}>
                                        {loading ? <i style={{ fontSize: "22px" }} className="fa-solid fa-spinner fa-spin" ></i> : <i className="fa-solid fa-magnifying-glass"></i>}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {allResults?.length > 0 ? <div className="row mt-4">
                        <div className="col-md-12">
                            <div className="popular-slider-arrow-box">
                                <i className="fa-solid fa-arrow-left" onClick={handlePrev}></i>
                                <i className="fa-solid fa-arrow-right" onClick={handleNext}></i>
                            </div>
                        </div>

                        <div className="col-md-12">
                            <Swiper
                                spaceBetween={30}
                                navigation={false}
                                autoplay={{
                                    delay: 2000,
                                    disableOnInteraction: false,
                                    pauseOnMouseEnter: true,
                                }}
                                modules={[Navigation, Autoplay]}
                                onSlideChange={handleSlideChange}
                                className="mySwiper"
                                ref={sliderRef}
                                breakpoints={{
                                    425: {
                                        slidesPerView: 1,
                                        spaceBetween: 0,
                                    },
                                    375: {
                                        slidesPerView: 1,
                                        spaceBetween: 0,
                                    },
                                    320: {
                                        slidesPerView: 1,
                                        spaceBetween: 0,
                                    },
                                    780: {
                                        slidesPerView: 2,
                                        spaceBetween: 15,
                                    },
                                    768: {
                                        slidesPerView: 2,
                                        spaceBetween: 20,
                                    },
                                    1280: {
                                        slidesPerView: 3,
                                        spaceBetween: 20,
                                    },
                                }}
                            >

                                {allResults?.map((professional, index) => {
                                    return <SwiperSlide>
                                        <Link to={`/service/provider/${professional?.id}`} key={index} style={{ textDecoration: 'none' }}>
                                            <div className="popular-professional-card popular-professional-white-card">
                                                <div className="popular-card-image">
                                                    <img src={`${base?.imageUrl}${professional?.images?.[0]?.path}`} alt="" />
                                                </div>

                                                <div className="popular-card-text">
                                                    <h1>{professional?.name}</h1>
                                                    <h3>{professional?.role?.name}</h3>
                                                    <div className="professional-services-box">
                                                        {professional?.services?.map((item, index) => (
                                                            <p>{item?.name}</p>
                                                        ))}
                                                    </div>

                                                    {quickSearchFilter.longitude &&
                                                        quickSearchFilter?.latitude &&
                                                        professional?.address?.latitude &&
                                                        professional?.address?.longitude &&
                                                        <h6 className="card-common-text">
                                                            {calculateDistance(
                                                                quickSearchFilter.longitude,
                                                                quickSearchFilter?.latitude,
                                                                professional?.address?.latitude,
                                                                professional?.address?.longitude
                                                            )} km away
                                                        </h6>}
                                                </div>
                                            </div>
                                        </Link>
                                    </SwiperSlide>
                                })}
                            </Swiper>
                        </div>
                    </div> : ""}

                    {/* <div className="row mt-5">
                    {allResults?.map((professional, index) => {
                        return <div className="col-md-4 mb-4">
                            <Link to={`/service/provider/${professional?.id}`} key={index} style={{ textDecoration: 'none' }}>
                                <div className="popular-professional-card popular-professional-white-card">
                                    <div className="popular-card-image">
                                        <img src={`${base?.imageUrl}${professional?.images?.[0]?.path}`} alt="" />
                                    </div>

                                    <div className="popular-card-text">
                                        <h1>{professional?.name}</h1>
                                        <h3>{professional?.role?.name}</h3>
                                        <div className="professional-services-box">
                                            {professional?.services?.map((item, index) => (
                                                <p>{item?.name}</p>
                                            ))}
                                        </div>

                                        {quickSearchFilter.longitude &&
                                            quickSearchFilter?.latitude &&
                                            professional?.address?.latitude &&
                                            professional?.address?.longitude &&
                                            <h6 className="card-common-text">
                                                {calculateDistance(
                                                    quickSearchFilter.longitude,
                                                    quickSearchFilter?.latitude,
                                                    professional?.address?.latitude,
                                                    professional?.address?.longitude
                                                )} km away
                                            </h6>}
                                    </div>
                                </div>
                            </Link>
                        </div>
                    })}
                </div> */}
                </div>
            </div>
        </>
    )
}

export default QuickSearchBanner